import React from 'react'
import { ISocialPlatform } from '@/interfaces/socials'

// styles
import {
  socialIconLinkContainer,
  socialIconLinkContainerGray,
  socialIconLinkContainerAnchor,
} from './styles'
import { getSocialUserUrl } from '@/shared/utils/getSocialUserUrl'
import { cssClass } from '@/shared/utils/styles'
import Link from 'next/link'
import { ImageFit } from '../images/ImageFit.component'
import {
  IMAGE_PATHS_V2,
  SOCIAL_ICONS,
  GRAY_SOCIAL_ICONS,
} from '../../../shared/consts/imagesPaths'

type BaseProps = {
  social: ISocialPlatform
  filterGray?: boolean
  size?: number
  onClick?: (platform: ISocialPlatform) => void
}

interface WithSocialAndUsernameProps extends BaseProps {
  username: string
}

interface WithCustomUrlProps extends BaseProps {
  customUrl: string
}

type Props = WithSocialAndUsernameProps | WithCustomUrlProps

export const SocialIconLink: React.FC<Props> = (props) => {
  const { social, filterGray = false, size = 32, onClick } = props
  const url =
    'customUrl' in props
      ? props.customUrl
      : getSocialUserUrl(social, props.username)
  const className = cssClass([
    socialIconLinkContainer,
    filterGray ? socialIconLinkContainerGray : '',
  ])

  const iconPath = filterGray ? GRAY_SOCIAL_ICONS[social] : SOCIAL_ICONS[social]

  return (
    <div
      onClick={() => onClick && onClick(social)}
      style={{ width: size, height: size }}
      className={className}
    >
      {onClick ? (
        <ImageFit
          src={IMAGE_PATHS_V2.icons.socials + iconPath}
          alt={`${social} icon`}
        />
      ) : (
        <Link href={url} target="_blank" legacyBehavior>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className={socialIconLinkContainerAnchor}
          >
            <ImageFit
              src={IMAGE_PATHS_V2.icons.socials + iconPath}
              alt={`${social} icon`}
            />
          </a>
        </Link>
      )}
    </div>
  )
}
